import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    const details = event.currentTarget.closest("details")
    const content = details.querySelector("[data-accordion-content]")
    const arrow   = details.querySelector("[data-accordion-arrow]")

    if (details.open) {
      // Close: animate down to 0 then remove open
      content.style.height = content.scrollHeight + "px"
      requestAnimationFrame(() => {
        content.style.transition = "height 260ms ease, opacity 220ms ease"
        content.style.height  = "0"
        content.style.opacity = "0"
      })
      content.addEventListener("transitionend", () => {
        details.removeAttribute("open")
        content.style.transition = ""
      }, { once: true })

      arrow?.classList.remove("accordion-arrow--open")
    } else {
      // Open: set open first so browser renders content, then animate
      details.setAttribute("open", "")
      const targetHeight = content.scrollHeight + "px"
      content.style.height  = "0"
      content.style.opacity = "0"
      content.style.transition = ""

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          content.style.transition = "height 260ms ease, opacity 220ms ease"
          content.style.height  = targetHeight
          content.style.opacity = "1"
        })
      })
      content.addEventListener("transitionend", () => {
        content.style.height = ""
        content.style.transition = ""
      }, { once: true })

      arrow?.classList.add("accordion-arrow--open")
    }

    event.preventDefault()
  }
}
